import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "suppliers";

export const dynamic = "force-dynamic";

export class SupplierService {
  // Token handled by cookie

  // add a new supplier
  async addSupplier(supplier) {
    try {
      const response = await axios.post(apiUrl, supplier, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get all suppliers
  async getSuppliers() {
    try {
      const response = await axios.get(apiUrl, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get a single supplier
  async getSupplier(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        withCredentials: true
      });

      const data = response.data;
      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // update a supplier
  async updateSupplier(supplier) {
    try {
      const response = await axios.put(`${apiUrl}/${supplier._id}`, supplier, {
        withCredentials: true
      });

      const data = response.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // delete a supplier
  async deleteSupplier(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        withCredentials: true
      });

      const data = response.data;

      if (!data.success) {
        throw new Error(data);
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}
